// Custom hook for page visit tracking
import { useEffect } from 'react';
import { trackPageVisit } from '../utils/analytics';

export const usePageTracking = (pageName) => {
  useEffect(() => {
    trackPageVisit(pageName);
  }, [pageName]);
};

export default usePageTracking;
